// Define the slides, with some containing scene-specific content
export const slides = [
    { type: 'image', heading: 'COVER', content: './presentation2/RENCO MINE_page-0001 (1).jpg' },
    {
      type: 'scene',
      heading: 'Overview',
      content: {
        visibleObjects: ['SATELLITE'],
        cameraPosition: [ 18941,20500 ,86000  ],
        lookAt: [18941, 600,81900],
        description:`<strong>OVERVIEW<strong> `
      }
    }
  ];